export default {
  date: 'November 12, 2024',
  title: 'Why does Real Estate Management trust to AI Getfloorplan?',
  description: 'More than 300  companies over the world trust us to create marketing materials',
  id: 'trust-factors',
  jsx: () => (
    <div class='novelty__text'>
      <p>More than 300 companies over the world trust us to create marketing materials</p>
      <p>
        <b>Here are compelling reasons to order 3D images from AI:</b>
      </p>
      <b>Speed and Efficiency</b>
      <p>AI-driven 3D modeling significantly reduces the time needed to create high-quality visualizations. What traditionally takes days or 3-5 days can be delivered in 24 hours. This speed helps real estate professionals and developers accelerate their sales and marketing processes.</p>
      <b>Cost-Effectiveness</b>
      <p>AI technology automates many manual tasks, reducing labor costs without compromising on quality. This makes 3D products more affordable compared to traditional methods, offering a great return on investment for businesses. It’s 20$ instead of 70-90$, on average.</p>
      <b>Customization and Scalability</b>
      <p>AI enables high levels of customization, allowing it to meet tailored specific client needs. Moreover, it’s easy to scale up production, whether you need one model or hundreds, ensuring flexibility for projects of all sizes.</p>
      <p>Write us to have a Demo for your project and get the special conditions.</p>
    </div>
  ),
  thumb: 'news/31.webp',
  button: 'Personal request',
};
